export const IN_BUCKET_LABEL = 'В корзину';
export const ONE_CLICK_BUY_LABEL = 'Купить в 1 клик';
export const APPLY_SALE_LABEL = 'Применить скидку';
export const SIGN_IN_LABEL = 'Войти';
export const PRIVACY_POLICE_LABEL =
    'Продолжая, я соглашаюсь с правилами и политикой конфиденциальности и принимаю их условия';
export const ACCEPT_PRIVACY_POLICE_LABEL = 'Примите условия политики конфиденциальности';
export const SEND_CODE_LABEL = 'Ваш код отправлен сообщением на email';
export const SIGN_BTN_TOOLTIP = 'Примите условия соглашения';
export const BUCKET_LABEL = 'Корзина';
export const SUCCESS_UPLOAD_BUCKET_GOOD = 'Товар успешно добавлен в корзину';
export const ERROR_UPLOAD_BUCKET_GOOD = 'Ошибка добавления товара';
export const REMOVE_LABEL = 'Удалить';
export const SUCCESS_REMOVE_BUCKET_GOOD = 'Товар удален из корзины';
export const ERROR_REMOVE_BUCKET_GOOD = 'Ошибка удаления товара';
export const CREATE_ORDER_LABEL = 'Оформить заказ';
export const COMMON_ORDER_FORM_LABEL = 'Ваш заказ';
export const SUCCESS_CREATE_ORDER = 'Заказ успешно создан, администратор свяжется с Вами';
export const ERROR_CREATE_ORDER = 'Ошибка формирования заказа, свяжитесь со службой поддержки';
export const TOTAL_ORDER_LABEL = 'Итого';
export const ORDER_FORM_LABEL = 'Оформление заказа';
export const FORM_CONTACTS_DATA_LABEL = 'Ваши контактные данные';
export const FORM_PAYMENT_TYPE_LABEL = 'Способ оплаты';
export const QUICK_PLACING_ORDER_LABEL =
    '* Если вы уже зарегистрированы на сайте, пожалуйста, авторизуйтесь. Это поможет ускорить процесс оформления заказа';
export const BANK_ACCOUNT_FORM_LABEL = 'Оплата производится по реквизитам Р/с:';
export const PAID_DELIVERY_LABEL = 'Расчет стоимости доставки осуществляется по прайсу';
export const EURO_MAIL_LABEL = 'evropochta.by';
export const DELIVERY_ADDRESS_LABEL = 'Укажите адрес доставки';
export const DELIVERY_TYPE_LABEL = 'Выберите способ доставки';
export const NOT_EXIST_PERSONAL_DATE_LABEL = 'Для создания заказа заполните телефон';
export const REQUIRED_FREE_DELIVERY_CITY_LABEL = 'Укажите город доставки';
export const REQUIRED_DELIVERY_ADDRESS_LABEL = 'Заполните адрес доставки';
export const SET_DELIVERY_ADDRESS_LABEL = 'Заполните телефон в личном кабинете';
export const BELORUSSIAN_FORMAT_PHONE =
    'Белорусский формат мобильного телефона ((29, 33, 44, 25)1234567)';
export const EMAIL_FORMAT_LABEL = 'Неверный формат почты';
export const GOODS_LINK_LABEL = 'Быстрый подбор товара';
export const TIRE_LABEL = 'Легковые шины';
export const CARGO_TIRE_LABEL = 'Грузовые шины';
export const BATTERY_LABEL = 'АКБ';
export const WHEEL_LABEL = 'Диски';
